import React, { CSSProperties, forwardRef, SVGAttributes } from 'react'

import { SvgProps } from '../base/SvgProps'

export interface SvgImageProps extends SvgProps {
    style?: CSSProperties
    attributes?: SVGAttributes<SVGSVGElement>
    className?: string
}

export const SvgImage = forwardRef<SVGSVGElement, SvgImageProps>((props, ref) => {
    const SvgItem = props.svg as React.ComponentType<React.SVGProps<SVGSVGElement>>
    const attributes = props.attributes || {}
    return <SvgItem ref={ref} className={props.className} style={props.style} {...attributes} />
})

SvgImage.displayName = 'SvgImage'
